export default (that) => [
  {
    field: "seq",
    width: 60,
    align: "center",
    fixed: "left",
    type: "seq",
  },
  {
    title: that.$l("table_label_qualityTime") || "报工日期",
    field: "qualityTime",
    minWidth: 150,
    align: "center",
    showHeaderOverflow: true,
  },
  {
    title: that.$l("table_label_status") || "状态",
    field: "status",
    minWidth: 80,
    align: "center",
    slots: { default: "status" },
    showHeaderOverflow: true,
  },
  {
    title: that.$l("table_label_userNo") || "员工工号",
    field: "userNo",
    minWidth: 120,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("table_label_userName") || "员工姓名",
    field: "userName",
    minWidth: 120,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("table_label_workShiftName") || "班次",
    field: "workShiftName",
    minWidth: 80,
    align: "center",
    showHeaderOverflow: true,
  },
  {
    title: that.$l("table_label_factoryOrderNo") || "工厂订单编号",
    field: "factoryOrderNo",
    minWidth: 180,
    align: "center",
    showHeaderOverflow: true,
  },
  {
    title: that.$l("table_label_custOrderNo") || "客户订单编号",
    field: "custOrderNo",
    minWidth: 180,
    align: "center",
    showHeaderOverflow: true,
  },

  {
    title: that.$l("table_label_custName") || "客户",
    field: "custName",
    minWidth: 140,
    align: "center",
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("table_label_masterNcNo") || "成品编码",
    field: "masterNcNo",
    minWidth: 120,
    align: "center",
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("table_label_goodsName") || "产品名称",
    field: "goodsName",
    minWidth: 200,
    align: "center",
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("table_label_goodsColor") || "颜色",
    field: "goodsColor",
    minWidth: 200,
    align: "center",
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("table_label_spec") || "尺寸",
    field: "spec",
    minWidth: 200,
    align: "center",
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: "displaySpec" },
  },
  {
    title: that.$l("table_label_ncNo") || "子件编码",
    field: "ncNo",
    minWidth: 200,
    align: "center",
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("table_label_checkedQty") || "单人批次数量",
    field: "checkedQty",
    minWidth: 200,
    align: "center",
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("table_label_passQty") || "单人良品数量",
    field: "passQty",
    minWidth: 200,
    align: "center",
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("table_label_notPassQty") || "单人不良品数量",
    field: "notPassQty",
    minWidth: 180,
    align: "center",
    showHeaderOverflow: true,
  },
  {
    title: that.$l("table_label_yield") || "良品率",
    field: "yield",
    minWidth: 180,
    align: "center",
    showHeaderOverflow: true,
    slots: { default: "displayYield" },
  },
  {
    title: that.$l("table_label_displayCreate") || "创建人",
    field: "displayCreate",
    width: 170,
    align: "center",
    showHeaderOverflow: true,
    slots: { default: "displayCreate" },
  },
  {
    title: that.$l("table_label_displayModify") || "修改人",
    field: "displayModify",
    width: 170,
    align: "center",
    showHeaderOverflow: true,
    slots: { default: "displayModify" },
  },
];
